import { render, staticRenderFns } from "./VerifyWill.vue?vue&type=template&id=71a79da5"
import script from "./VerifyWill.vue?vue&type=script&lang=js"
export * from "./VerifyWill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports